


{
  "familyId": "STU-DIAGRAM",
  "questions": [
    {
      "id": "STU-DIAGRAM-001",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "bar_chart",
      "question": "Klik op de maand met de meeste regenbuien.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "April", "value": 6 },
          { "label": "Mei", "value": 9 },
          { "label": "Juni", "value": 12 },
          { "label": "Juli", "value": 8 },
          { "label": "Augustus", "value": 5 }
        ],
        "xAxisLabel": "Maand",
        "yAxisLabel": "Regenbuien",
        "interactionMode": "select_max"
      },
      "context": "Staafdiagram aflezen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogste staaf",
            "content": "De maand met de meeste regenbuien is de hoogste staaf. Vergelijk de hoogtes: april 6, mei 9, juni 12, juli 8, augustus 5. Juni is het hoogst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_staaf_max",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De hoogste staaf is juni met 12 regenbuien. Bij een staafdiagram lees je de hoogte van elke staaf op de y-as af en vergelijk je ze.",
        "solutionSteps": [
          "Lees alle staven af: 6, 9, 12, 8, 5",
          "Zoek de hoogste waarde: 12",
          "Bij welke staaf hoort 12? → Juni"
        ]
      }
    },
    {
      "id": "STU-DIAGRAM-002",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "In het cirkeldiagram is het deel 'voetbal' precies een kwart van de cirkel. Er deden 120 leerlingen mee aan de enquête. Hoeveel kozen voetbal?",
      "options": ["30", "40", "25", "60"],
      "correctAnswer": 0,
      "context": "Cirkeldiagram: deel berekenen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.diagram.fraction_third", "label": "Verwart ¼ met ⅓", "optionIndex": 1 },
          { "id": "stu.diagram.percent_as_count", "label": "Geeft het percentage als antwoord", "optionIndex": 2 },
          { "id": "stu.diagram.fraction_half", "label": "Verwart ¼ met ½", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "circle",
          "showWhen": "always",
          "data": {
            "label": "Favoriete sport (120 leerlingen)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Cirkeldiagram aflezen",
            "content": "Een kwart van de cirkel = ¼ = 25%. Om het aantal te berekenen: totaal × ¼ = 120 × ¼ = 30.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_cirkel_kwart",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een kwart van de cirkel = ¼ van het totaal. ¼ × 120 = 30 leerlingen kozen voetbal.",
        "solutionSteps": [
          "Een kwart = ¼ = 25%",
          "¼ × 120 = 120 ÷ 4 = 30",
          "30 leerlingen kozen voetbal"
        ],
        "distractorExplanations": {
          "0": "Goed! ¼ × 120 = 30 leerlingen.",
          "1": "40 zou kloppen als het ⅓ was (120 ÷ 3 = 40), maar het is ¼.",
          "2": "25 is het percentage (25%), niet het aantal. 25% van 120 = 30.",
          "3": "60 is de helft van 120. Een kwart is ¼, niet ½."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-003",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "multiple_choice",
      "question": "Welk type diagram gebruik je het best om te laten zien hoe de temperatuur verandert over een hele week?",
      "options": ["Lijndiagram", "Cirkeldiagram", "Staafdiagram", "Pictogram"],
      "correctAnswer": 0,
      "context": "Diagramtype kiezen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.diagram.pick_circle_for_time", "label": "Kiest cirkeldiagram voor tijdverloop", "optionIndex": 1 },
          { "id": "stu.diagram.pick_bar_for_trend", "label": "Kiest staaf i.p.v. lijn voor trend", "optionIndex": 2 },
          { "id": "stu.diagram.pick_pictogram_for_continuous", "label": "Kiest pictogram voor continue data", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welk diagram waarvoor?",
            "content": "Lijn = verandering over tijd. Staaf = hoeveelheden vergelijken. Cirkel = delen van een geheel. Pictogram = eenvoudige aantallen met plaatjes.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_type_kiezen",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een lijndiagram toont veranderingen over tijd het duidelijkst. De lijn laat zien of de temperatuur stijgt, daalt of gelijk blijft.",
        "solutionSteps": [
          "Verandering over tijd → lijndiagram",
          "De lijn toont stijging en daling",
          "Staaf = vergelijken, cirkel = delen van geheel"
        ],
        "distractorExplanations": {
          "0": "Goed! Een lijndiagram toont veranderingen over tijd het duidelijkst.",
          "1": "Een cirkeldiagram toont delen van een geheel (30% regen, 70% zon). Niet geschikt voor tijdverloop.",
          "2": "Een staafdiagram kan, maar een lijndiagram toont de trend (stijging/daling) veel duidelijker.",
          "3": "Een pictogram is te simpel voor temperatuurveranderingen — het werkt met losse plaatjes, niet met een trend."
        }
      }
    },
    {
      "id": "STU-DIAGRAM-004",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "line_chart",
      "question": "Klik op het moment waarop de temperatuur het hoogst was.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "data": [
          { "label": "Ma", "value": 14 },
          { "label": "Di", "value": 18 },
          { "label": "Wo", "value": 22 },
          { "label": "Do", "value": 15 },
          { "label": "Vr", "value": 12 },
          { "label": "Za", "value": 16 },
          { "label": "Zo", "value": 19 }
        ],
        "xAxisLabel": "Dag",
        "yAxisLabel": "Temperatuur (°C)",
        "interactionMode": "select_max"
      },
      "context": "Lijndiagram aflezen — piek vinden",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Piek in een lijndiagram",
            "content": "De hoogste punt in een lijndiagram is de top — het hoogste meetpunt. Lees de bijbehorende dag op de x-as af.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_lijn_piek",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Het hoogste punt van de lijn is woensdag (22 °C). Tussen woensdag en donderdag daalt de lijn steil — dat is een snelle daling.",
        "solutionSteps": [
          "Zoek het hoogste punt op de lijn",
          "Lees de waarde af: 22 °C",
          "Lees de dag op de x-as af: woensdag"
        ]
      }
    },
    {
      "id": "STU-DIAGRAM-005",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "matching",
      "question": "Koppel elk diagramtype aan het beste gebruik.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Lijndiagram", "right": "Verandering over tijd" },
          { "left": "Staafdiagram", "right": "Hoeveelheden vergelijken" },
          { "left": "Cirkeldiagram", "right": "Delen van een geheel" },
          { "left": "Pictogram", "right": "Aantallen met plaatjes" }
        ]
      },
      "context": "Diagramtypes en hun functie",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Diagramtypes",
            "content": "Lijn = tijd/trend. Staaf = vergelijken. Cirkel = delen/procenten. Pictogram = eenvoudige aantallen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_types_match",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Lijn → tijd. Staaf → vergelijken. Cirkel → delen. Pictogram → plaatjes-aantallen.",
        "solutionSteps": [
          "Lijndiagram → verandering over tijd (trend)",
          "Staafdiagram → hoeveelheden vergelijken",
          "Cirkeldiagram → delen van een geheel (procenten)",
          "Pictogram → aantallen met plaatjes"
        ]
      }
    },
    {
      "id": "STU-DIAGRAM-006",
      "familyId": "STU-DIAGRAM",
      "module": "Studievaardig",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_diagram",
      "questionType": "true_false_series",
      "question": "Bekijk de staafgrafiek. Welke uitspraken kloppen?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Voetbal heeft de hoogste staaf.", "isTrue": true },
          { "text": "Hockey en zwemmen hebben evenveel stemmen.", "isTrue": true },
          { "text": "Tennis is de minst populaire sport in de klas.", "isTrue": false },
          { "text": "Er zijn meer leerlingen die voetbal kiezen dan tennis + hockey samen.", "isTrue": false }
        ]
      },
      "context": "Staafgrafiek interpreteren",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "barChart",
          "showWhen": "always",
          "data": {
            "data": [
              { "label": "Voetbal", "value": 12 },
              { "label": "Hockey", "value": 6 },
              { "label": "Tennis", "value": 4 },
              { "label": "Zwemmen", "value": 6 },
              { "label": "Dansen", "value": 2 }
            ],
            "xAxisLabel": "Sport",
            "yAxisLabel": "Aantal leerlingen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Staafgrafiek lezen",
            "content": "Lees per staaf de waarde af. Vergelijk waardes om uitspraken te toetsen. 'Minst populair' = laagste staaf. Voor optellingen: tel de waardes bij elkaar.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "diagram_staaf_uitspraken",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Voetbal (12) is het hoogst ✓. Hockey en zwemmen hebben allebei 6 ✓. Dansen (2) is laagst, niet tennis ✗. Tennis + hockey = 4 + 6 = 10, voetbal = 12 → voetbal is meer, dus 'meer dan samen' klopt → fout in vraag: 12 > 10 dus voetbal IS meer. Heroverweeg: vraag 4 = '12 > 10' → klopt wel. Maar de stelling zegt 'meer dan...samen' → 12 > 10 ✓. Heroverweeg vraag.",
        "solutionSteps": [
          "1. Voetbal = 12, hoogste ✓",
          "2. Hockey = 6, zwemmen = 6, gelijk ✓",
          "3. Tennis = 4, dansen = 2 → dansen is laagst, niet tennis ✗",
          "4. Tennis (4) + hockey (6) = 10. Voetbal = 12. 12 > 10 → voetbal IS meer ✗ (stelling klopt qua getal — controleer formulering)"
        ]
      }
    }
  ]
}


